import { useTheme } from '@mui/material/styles';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from '@remix-run/react';

const Goby = (): JSX.Element => {
	const { userLanguage } = useLoaderData();
	const link_prefix = userLanguage === 'en' ? '/en' : '';
	let { t } = useTranslation(['websites']);
	const theme = useTheme();

	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	return (
		<Box
			sx={{
				position: 'relative',
				width: 'auto',
				height: 'auto',
			}}
		>
			<Box
				zIndex={1}
				sx={{
					position: 'absolute',
					width: '100%',
					height: '105%',
					background: 'rgb(0 0 0 / 0%)',
					backdropFilter: 'blur(2px)',
					borderRadius: '0px',
				}}
			/>
			<Box zIndex={2} position={'relative'} pt={'0rem'} pb={'0rem'}>
				<Typography
					component='h2'
					variant='h3'
					align={'center'}
					gutterBottom
					sx={{
						fontWeight: 700,
						color: theme.palette.common.white,
						// backdropFilter: blur(2px),

						// mixBlendMode: 'difference'

						// textTransform: 'uppercase'
					}}
				>
					{t('goby_Headline', { hyphen: '\u00AD' })}
				</Typography>

				<Typography
					pt={'0.5em'}
					pb={'0rem'}
					variant={isMd ? 'body1' : 'body1'}
					component='p'
					color='#ffffffed'
					align={'center'}
				>
					{t('goby_Subheadline')}
				</Typography>

				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						marginTop: '10px',
					}}
				>
					<Link
						to={link_prefix + '/hire-us/'}
						prefetch='intent'
						style={{
							textDecoration: 'none',
						}}
						onClick={(e) => {
							e.stopPropagation();
							// e.preventDefault();
						}}
					>
						<Button
							component={'div'}
							size={'large'}
							sx={{
								marginTop: 1,
								borderRadius: 0,
								margin: 3,
								// padding: 3,
								// fontSize: '1.2rem',
								color: '#ffffffed',
								'&:hover': {
									backgroundColor: 'transparent',
								},
							}}
							// color={'primary'}
							// color={theme.palette.mode === 'light' ? 'secondary' : 'secondary'}

							endIcon={
								<Box
									component={'svg'}
									xmlns='http://www.w3.org/2000/svg'
									fill='#FF6600'
									viewBox='0 0 48 48'
									stroke='#FF6600'
									width={24}
									height={24}
								>
									<path d='m28.05 35.9-2.15-2.1 8.4-8.4H8v-3h26.3l-8.45-8.45 2.15-2.1L40.05 23.9Z' />
								</Box>
							}
						>
							{t('learnMore')}
						</Button>
					</Link>
				</Box>
			</Box>
		</Box>
	);
};

export default Goby;
